import { useIntlContext } from '@inbox-demo-nx/contexts';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import isSameDay from 'date-fns/isSameDay';
import isSameYear from 'date-fns/isSameYear';
import { useCallback } from 'react';

export function useFormatChannelUpdatedAt() {
  const { intlDateFormat, intlDateDifferentYearFormat } = useIntlContext();

  return useCallback(
    (updatedAt: number) => {
      const formatDistanceToNowResult = formatDistanceToNow(updatedAt);
      const relativeTime =
        formatDistanceToNowResult === '0s ago'
          ? 'Now'
          : formatDistanceToNowResult;

      if (isSameDay(updatedAt, new Date())) {
        return relativeTime;
      }
      if (isSameYear(updatedAt, new Date())) {
        return intlDateFormat.format(updatedAt);
      }
      return intlDateDifferentYearFormat.format(updatedAt);
    },
    [intlDateDifferentYearFormat, intlDateFormat]
  );
}
